/*
 * Copyright (c) 2024. Bluemate B.V.
 */
import './style/routerLink.scss';

import React, {PropsWithChildren} from 'react';

import {Link, LinkProps} from 'react-router';

import classNames from 'classnames';

export default function RouterLink(props: PropsWithChildren<LinkProps>) {
    function renderTitle() {
        const {title} = props;
        if (!title) return null;
        return <span className='link-title'>{title}</span>;
    }

    return (
        <Link {...props} title={undefined} className={classNames(props.className, 'router-link')}>
            {renderTitle()}
            {props.children}
        </Link>
    );
}
